module.exports = __webpack_public_path__ + "img/02-8.a80a78c3.png";